/*****************************************************/
/* 処　理：SMS011 エラー 画面
/*
/* 概　要：定数定義
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/

// 処理名
export const INIT_NAME = '初期表示';
export const BTN_OK_NAME = 'OK';
export const BTN_BACKMENU_NAME = 'メニューへ戻る';
